import Event from "../sports/common/event";
import mapDate from "./date-mapper";

const mapEvent = (jsonObj) => {
    if (jsonObj) {
        const event = Object.assign(new Event(), jsonObj);
        event.startDateTime = mapDate(event.startDateTime);

        return event;
    }

    return null;
};

export { mapEvent };
